isSingleASTNode